import axios from "axios";
import { auditPost } from "../api/config";

const api = axios.create({
	baseURL: process.env.REACT_APP_AUTH_URL,
	withCredentials: true,
});

const encodeUTF8 = (str) => new TextEncoder().encode(str);

const encryptData = async (data, secretKey) => {
	const iv = window.crypto.getRandomValues(new Uint8Array(16));

	const key = await window.crypto.subtle.importKey(
		"raw",
		encodeUTF8(secretKey),
		{ name: "AES-CBC" },
		false,
		["encrypt"]
	);

	const encryptedData = await window.crypto.subtle.encrypt(
		{
			name: "AES-CBC",
			iv: iv,
		},
		key,
		encodeUTF8(data)
	);

	const combined = new Uint8Array(iv.length + encryptedData.byteLength);
	combined.set(iv);
	combined.set(new Uint8Array(encryptedData), iv.length);

	return btoa(String.fromCharCode(...combined));
};

const handleAuthError = (setAuthenticated) => {
	setAuthenticated(false);
};

const logging = async (
	event,
	setLoading,
	username,
	password,
	setAuthenticated,
	getModuleId,
	setCredentialsError,
	isEmbedded
) => {
	event.preventDefault();
	setLoading(true);

	if (isEmbedded) {
		setAuthenticated(true);
		setLoading(false);
		return;
	}

	const headers = {
		"Content-Type": "application/x-www-form-urlencoded",
		Accept: "application/json",
	};

	const secretKey = process.env.REACT_APP_SECRET_KEY;

	try {
		const encryptedUsername = await encryptData(username, secretKey);
		const encryptedPassword = await encryptData(password, secretKey);

		const data = new URLSearchParams();
		data.append("username", encryptedUsername);
		data.append("password", encryptedPassword);

		const response = await api.post(`/user/token`, data, { headers });
		const dataResponse = response.data;
		if (dataResponse.access_token) {
			sessionStorage.setItem("access_token", dataResponse.access_token);
		}

		if (response.status === 200) {
			setAuthenticated(true);
			setLoading(false);
			setCredentialsError({ error: false, message: "" });
		} else {
			handleAuthError(setAuthenticated);
			setLoading(false);
		}
	} catch (error) {
		setCredentialsError({
			error: true,
			message: "Usuario o contraseña incorrectos",
		});
		console.error("Error durante el inicio de sesión:", error);
		handleAuthError(setAuthenticated);
		setLoading(false);
	}
};

const checkSession = async (setAuthenticated, getModuleId, site_id) => {
	try {
		const response = await api.get(`/user/current`);
		if (response.status === 200) {
			setAuthenticated(true);
		} else {
			handleAuthError(setAuthenticated);
			const moduleId = getModuleId("Login", "Log Out");
			auditPost(moduleId, site_id);
		}
	} catch (error) {
		console.error("Error al verificar la sesión:", error);
		handleAuthError(setAuthenticated);
		const moduleId = getModuleId("Login", "Log Out");
		auditPost(moduleId, site_id);
	}
};

api.interceptors.response.use(
	(r) => r,
	(error) => {
		if (error.response && error.response.status === 401) {
			handleAuthError();
		}
		return Promise.reject(error);
	}
);

const validateUsername = (username) => {
	const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
	return regex.test(username);
};

const validatePassword = (password) => {
	const regex = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
	return regex.test(password);
};

export { validateUsername, validatePassword, logging, checkSession };
